import type { UserReportItemDto } from '@/data/dtos/report/userReportItemDto';
import type { JsonObject } from '@/data/types/json';
import type { UserReportItemEntity } from '@/domain/entities/report/userReportItemEntity';

export class UserReportItemRemapper {
  static fromJson(data: JsonObject): UserReportItemDto {
    return {
      id: (data['id'] as string | undefined) || '',
      parentId: (data['parentId'] as string | null | undefined) ?? null,
      title: (data['title'] as string | undefined) || '',
      description: (data['description'] as string | null | undefined) ?? null,
      order: (data['order'] as number | undefined) || 0,
      isSubmit: (data['isSubmit'] as boolean | undefined) ?? false,
    };
  }

  static toEntity(data: any): UserReportItemEntity {
    const dto = this.fromJson(data);
    return { ...dto } as UserReportItemEntity;
  }

  static fromJsonList(dataList: JsonObject[]): UserReportItemEntity[] {
    return dataList.map(data => this.toEntity(data));
  }
}
